var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFile = function SvgFile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M13.882 1.988a2.86 2.86 0 0 1 2.028.84l3.378 3.377h-.001a2.86 2.86 0 0 1 .842 2.03V19.53a2.485 2.485 0 0 1-2.482 2.483H6.353a2.484 2.484 0 0 1-2.482-2.483V4.471a2.484 2.484 0 0 1 2.482-2.483zm-7.529 1.2A1.284 1.284 0 0 0 5.07 4.47v15.058a1.285 1.285 0 0 0 1.283 1.282h11.294a1.284 1.284 0 0 0 1.282-1.282V8.835h-4.105a1.54 1.54 0 0 1-1.541-1.541V3.188zm8.129 4.106a.343.343 0 0 0 .342.34h3.992q-.006-.019-.014-.038a1.7 1.7 0 0 0-.362-.541l-3.379-3.38a1.7 1.7 0 0 0-.54-.36q-.02-.008-.04-.015z"
  })));
};
export default SvgFile;